import { Component, Input } from '@angular/core';

/**
 * Renders the default image if there is none for the product
 */
@Component({
    selector: '[render-product-image]',
    template: `@if (!image) {
  <img
    src="/images/fallback-product.png"
    height="{{ height }}"
    width="{{ width }}" />
}
@if (image) {
  <img
    src="https://img.noviflora.com/images/{{ image }}/{{ imageFormat }}.jpg"
    height="{{ height }}"
    width="{{ width }}"
    alt="{{ description }}"
    loading="lazy"
    title="{{ titleDescription }}" />
}`,
    standalone: true
})
export class RenderProductImageComponent {
  @Input() image: string;
  @Input() titleDescription: string;
  @Input() description: string;
  @Input() imageFormat: number = 490;
  @Input() objectFit: string = 'contain';
  @Input() width: number = 88;
  @Input() height: number = 88;
}
